import 'metismenu';
// import toastr from 'toastr';
// import beautify from './beautify';
var Swal = require('sweetalert2/dist/sweetalert2.js');

function __(key, defaultText) {
    return window.Translations?.[key] || defaultText || key;
}
window.__ = __;

/**
 * Serialize A Form To JSON
 */
 (function ($) {
    $.fn.serializeFormJSON = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
})(jQuery);

$(function() {
    $(document).on('keydown', '.prevent',function (e) {
        var charCode = (e.which) ? e.which : e.keyCode;
        if (charCode == 13) {
            e.preventDefault();
            return false;
        }
    });

    /**
     * Allow only number & Decimal
     */
    $(document).on('keypress', '.decimal, .float, .double, .percentage',function (event) {
        return isNumber(this, event)
    });

    function isNumber(elem, evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if (charCode == 13) return true;

        if (charCode == 45) {
            if (elem.value.indexOf('-') === -1) return true;
            return false;
        }

        if (elem.value.indexOf('%') !== -1){
            if((elem.value.length - elem.value.indexOf('%')) > 1) return false;
        }

        if (charCode == 37) {
            if (elem.value.indexOf('%') === -1) return true;
            return false;
        }
        if (charCode == 46) {
          if (elem.value.indexOf('.') === -1) {
            return true;
          } else {
            return false;
          }
        } else {
          if (charCode > 31 &&
            (charCode < 48 || charCode > 57))
            return false;
        }
        return true;
    }

    // Sidebar Menu
    setTimeout(function () {
        $(".vertical-nav-menu").metisMenu();
    }, 1000);

    $('.dropdown-menu').on('click', function (event) {
        var events = $._data(document, 'events') || {};
        events = events.click || [];
        if($(event.target).attr('data-dismiss') === 'dropdown') return true
        for (var i = 0; i < events.length; i++) {
            if (events[i].selector) {

                if ($(event.target).is(events[i].selector)) {
                    events[i].handler.call(event.target, event);
                }

                $(event.target).parents(events[i].selector).each(function () {
                    events[i].handler.call(this, event);
                });
            }
        }
        event.stopPropagation(); //Always stop propagation
    });


	$('.stopPropagation').on('click', function(e){
		e.stopPropagation();
	})

    $(function () {

        $('[data-click]').on('click', function(e){
            e.preventDefault();
            var _elem = $(this).data('click');
            $(this).closest('#export_buttons').find(_elem).trigger('click');
        })


        $('[data-clear]').on('click', function(e){
            e.preventDefault();
            var _elem = $(this).data('clear');
            $(this).closest('div').find(_elem)
            .find('input:text, input:password, select')
            .each(function () {
                $(this).val('').trigger('change');
            })
        })

        $('[data-trigger]').on('click', function(e){
            e.preventDefault();
            var _elem = $(this).data('trigger');
            $(_elem).trigger('click');
        })

        $(document).on('click', '[data-toggle=print]', function(){
            var _elem = $(this).data('target');
            // var restorepage = $('body').html();
            var printcontent = $(_elem).clone().addClass('print_view');
            $('body').hide();
            $('html').append(printcontent);
            window.print();
            $('.print_view').remove();
            $('body').show();
        })

        $(document).on('click', '[data-toggle=print-url]', function(e){
            var newWin = window.open($(this).data('target'));

            newWin.addEventListener('load', function(){
                newWin.focus();
                newWin.print();
                newWin.onafterprint = function () {
                    newWin.close();
                }

            });
        })

        /**
         * Extra Data-Toggle Functionalities
         * data-toggle clipboard
         * copy input val to clipboard
         */

        $(document).on('click', '[data-toggle=clipboard]', function (e) {
            e.preventDefault();
            var target = $(this).data('target');
            var text = $(this).data('text');
            var $btn = $(this);
            var originalHtml = $btn.html();

            if (text) {
                navigator.clipboard.writeText(text).then(function () {
                    $btn.removeClass('text-success').addClass('text-success');
                    $btn.html('<i class="fa-solid fa-check"></i> ' + 'Copied!');
                    setTimeout(function () {
                        $btn.removeClass('text-success').html(originalHtml);
                    }, 1500);
                });
            } else if (target) {
                $(target).trigger('select');
                document.execCommand('copy');
                $btn.removeClass('text-success').addClass('text-success');
                $btn.html('<i class="fa-solid fa-check"></i> ' + 'Copied!');
                setTimeout(function () {
                    $btn.removeClass('text-success').html(originalHtml);
                }, 1500);
            }
        });

        /**
         * Extra Data-Toggle Functionalities
         * data-toggle email
         * data-target url to send ajax_request
         */
        $(document).on('click', '[data-toggle=email]', function(){
            var url = $(this).data('target');

            Swal.fire({
                title: 'Type an email address',
                input: 'email',
                inputAttributes: {
                autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Send',
                showLoaderOnConfirm: true,
                preConfirm: (email) => {
                    let formData = new FormData();
                    formData.append('email', email);
                    formData.append('_token', csrf_token);
                    return fetch(url,{
                        body: formData,
                        method: "post"
                    }).then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json()
                    }).catch(error => {
                        Swal.showValidationMessage(
                            `Request failed: ${error}`
                        )
                    })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                console.log(result)
                Swal.fire({
                    icon: result.value.status,
                    text: result.value.message,
                })
            })
        })
    });

    $('.mobile-toggle-nav').on('click', function () {
        $(this).toggleClass('is-active');
        $('.app-container').toggleClass('sidebar-mobile-open');
    });

    $('.mobile-toggle-header-nav').on('click', function () {
        $(this).toggleClass('active');
        $('.app-header__content').toggleClass('header-mobile-open');
    });



    // Responsive
    var resizeClass = function () {
        var win = document.body.clientWidth;
        if (win < 1250) {
            $('.app-container').addClass('closed-sidebar-mobile closed-sidebar');
        } else {
            $('.app-container').removeClass('closed-sidebar-mobile closed-sidebar');
        }
    };
    // console.log("App Started...")

    $(window).on('resize', function () {
        resizeClass();
    });

    resizeClass();

    initEasyAjax();
    function initEasyAjax(){
        $('.ajax').easyajax({
            before_ajax: function(elem){
                // var str_loading = beautify.loading('Updating...');
                var str_loading = 'Updating...';
                $(elem).find(":submit").html(str_loading);
            },
            after_ajax: function(elem, response){
                if(response.trigger){
                    $(document).trigger(response.trigger);
                }
            },
            error_ajax: function(elem, xhr){
                console.log('Error ajax: from functions.js')
                // if(xhr.status == 422){
                    let err = xhr.responseJSON;
                    if(err.message){
                        var errorMessage = err.message ? err.message : 'Oops! Something went wrong. Please try again.';
                        beautify.notify('error', errorMessage);
                    }
                    $.each(err.errors, function(key, value){
                        if(key.startsWith('#')){
                            $(elem).find(key).attr('data-original-title', value[0]);
                            $(elem).find(key).removeClass('is-valid').addClass('is-invalid').tooltip({
                                template: '<div class="tooltip"><div class="tooltip-inner bg-danger"></div></div>',
                                placement: 'left'
                            })
                            $(elem).find(key).find('.batch').removeClass('is-valid').addClass('is-invalid')

                            return true;
                        }

                        if(key.includes(".")){
                            // Show error for indexed inputs
                            key = key.split(".");
                            var name_index = key[1];
                            key = key[0]
                            value[0] = value[0].replace('.'+name_index, '');

                            $(elem).find('[name="'+key+'[]"]').eq(name_index).removeClass('is-valid').addClass('is-invalid');
                            $(elem).find('[name="'+key+'[]"]').eq(name_index).closest('div').find('.error').text(value[0]);
                        }

                        $(elem).find($("[name='"+key+"']")).removeClass('is-valid').addClass('is-invalid');
                        $(elem).find($("[name='"+key+"']")).closest('div').find('.error').text(value[0]);

                    });
                // }
            },
            after_render: function(elem, response){

            },
            notification: function(data){
                if(data.message){
                    if(data.redirect){
                        beautify.notifyAndRedirect(data.status, data.message, data.redirect);
                    }else{
                        beautify.notify(data.status, data.message);
                    }
                }
            },
            ajax_form: '.ajax',
            ajax_link: '.ajax',
            csrf_token: $('meta[name="csrf-token"]').attr('content')
        });
    }






    // ----------------------- //
    // -------AJAX CONFIRM-----//


    function sweetConfirm(title, message, callback) {
        Swal.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true
        }).then((confirmed) => {
            callback(confirmed && confirmed.value == true);
        });
    }


    // set today date in datepicker class today
    let today = new Date();
    // today = moment(today).format("YYYY-MM-DD");
    $('.today').val(today);

    // select all text of input on click
    $(document).on('click', '.select', function(){
        $(this).trigger('select');
    });

    // show or hide pass
    $('.show_password').on('mousedown', function(e){
        e.preventDefault();
        $('#password').attr('type', function(index, attr){
            return attr == 'password' ? 'text' : 'password';
        });
    }).on('mouseup', function(e){
        e.preventDefault();
        $('#password').attr('type', function(index, attr){
            return attr == 'text' ? 'password' : 'text';
        });
    });

    // ── Format bank account number with dot separator every 4 chars ──────
    $(document).on('shown.bs.modal', '#myModal', function () {
        $(this).find('.bank-account').each(function () {
            var text = $(this).text().trim();
            if (text && text !== '-') {
                $(this).html(text.replace(/(.{4})(?=.)/g, '$1<span style="color:#ced4da; margin:0 2px; user-select:none">·</span>'));
            }
        });
    });

});

